import moment, { Moment } from 'moment';

import { SchoolHolidayTerm, SchoolHolidayType } from '../../legacy/types';
import {
  getCurrentOrUpcomingSchoolPeriod,
  getCurrentSchoolPeriod,
  getUpcomingSchoolPeriod,
  isWithinSchoolPeriod,
} from './sharedSchoolPeriodHelpers';

export const schoolTermTypes: SchoolHolidayType[] = ['School Term'];

export const isWithinSchoolTerm = (date: string | Moment, term: SchoolHolidayTerm) => {
  return isWithinSchoolPeriod(date, term);
};

export const getCurrentSchoolTerm = (
  upcomingTermsAndHolidays: Array<SchoolHolidayTerm>,
  overrideCurrentDate?: string | Moment
) => {
  return getCurrentSchoolPeriod(upcomingTermsAndHolidays, schoolTermTypes, overrideCurrentDate);
};

export const getUpcomingSchoolTerm = (
  schoolTermsAndHolidays: Array<SchoolHolidayTerm>,
  overrideCurrentDate?: string | Moment
) => {
  return getUpcomingSchoolPeriod(schoolTermsAndHolidays, schoolTermTypes, overrideCurrentDate);
};

export const getCurrentOrUpcomingSchoolTerm = (
  upcomingTermsAndHolidays: Array<SchoolHolidayTerm>,
  overrideCurrentDate?: string | Moment
) => {
  return getCurrentOrUpcomingSchoolPeriod(upcomingTermsAndHolidays, schoolTermTypes, overrideCurrentDate);
};

export const getNextSchoolTerm = (
  schoolTermsAndHolidays: Array<SchoolHolidayTerm>,
  overrideCurrentDate?: string | Moment
) => {
  const currentDateOverride = overrideCurrentDate ? moment(overrideCurrentDate) : moment();
  const currentDate = currentDateOverride.isValid() ? currentDateOverride : moment();

  // Get current term or holiday
  const currentPeriod = getCurrentSchoolPeriod(schoolTermsAndHolidays, ['School Term', 'Summer Holiday'], currentDate);

  // If we're in Term 4 or Summer Holiday, return Term 1 (next year)
  if (currentPeriod) {
    if (currentPeriod.type === 'School Term' && currentPeriod.schoolTerm === 'Term 4') {
      // Find Term 1 of the next year specifically
      const currentYear = moment(currentPeriod.startDate).year();
      const nextYear = currentYear + 1;

      const term1 = schoolTermsAndHolidays.find(
        (period) =>
          period.type === 'School Term' &&
          period.schoolTerm === 'Term 1' &&
          moment(period.startDate).year() === nextYear
      );
      return term1;
    }

    if (currentPeriod.type === 'Summer Holiday') {
      // Find Term 1 of the next year specifically
      const currentYear = moment(currentPeriod.startDate).year();
      const nextYear = currentYear + 1;

      const term1 = schoolTermsAndHolidays.find(
        (period) =>
          period.type === 'School Term' &&
          period.schoolTerm === 'Term 1' &&
          moment(period.startDate).year() === nextYear
      );
      return term1;
    }
  }

  // Otherwise, return the next upcoming term
  const upcomingTerms =
    schoolTermsAndHolidays
      ?.filter((period) => period.type === 'School Term' && moment(period.startDate).isAfter(currentDate, 'seconds'))
      ?.sort((a, b) => moment(a.startDate).diff(moment(b.startDate), 'seconds')) || [];

  return upcomingTerms[0] || undefined;
};
